<template>
  <section>
    <inventory-supplemental-cost-component v-if="inventoryMissingCosts"
      v-for="cost in costsCompilation"
      :key="cost.inventory.id"
      :isCollapsed="false"
      v-model="cost.supplementalCosts"
      :restoreByDefault="true"
      :selectedMakeModel="cost.selectedMakeModel"
      :selectedTypeStatus="cost.selectedTypeStatus"
      :selectedDispositionIntentionStatus="cost.selectedDispositionIntentionStatus"
      :isHidden="true">
    </inventory-supplemental-cost-component>
  </section>
</template>

<script>

import InventorySupplementalCostComponent from '@/components/generic/inventory/InventorySupplementalCostComponent'
import eventBus from '@/eventBus'
import { createNamespacedHelpers } from 'vuex'
const mapVehicleMakeGetters = createNamespacedHelpers('vehicleMake').mapGetters
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  name: 'AutoAddInventoryDefaultCostsComponent',
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  components: {
    'inventory-supplemental-cost-component': InventorySupplementalCostComponent
  },
  data () {
    return {
      supplementalCosts: [],
      selectedMakeModel: null,
      selectedTypeStatus: null,
      selectedDispositionIntentionStatus: null,
      inventoryMissingCosts: false
    }
  },
  computed: {
    ...mapVehicleMakeGetters(['allVehicleMakes']),
    ...mapConfigGetters(['definedTypes']),
    dealId: function () {
      return this.value.id
    },
    soldOrderDealItems: function () {
      return (this.value && this.value.items) ? this.value.items.filter((x) => x.dealItemType === 'Sold') : []
    },
    tradeOrderDealItems: function () {
      return (this.value && this.value.items) ? this.value.items.filter((x) => x.dealItemType === 'Trade') : []
    },
    soldAndTradeItems: function () {
      return [...this.soldOrderDealItems, ...this.tradeOrderDealItems]
    },
    soldInventory: function () {
      return this.soldOrderDealItems && this.soldOrderDealItems[0] ? this.soldOrderDealItems[0].forInventory : null
    },
    costsCompilation: function () {
      let costsCompilation = []
      if (this.inventoryMissingCosts) {
        this.soldAndTradeItems.forEach(item => {
          if (item.inventoryCostsUpdated && item.inventoryCostsUpdated === true) {
            let inventory = item.forInventory
            let make = this.getMake(inventory.vehicleMakeId)
            let model = this.getModel(make, inventory.vehicleMakeVersionId)
            let typeStatus = this.getTypeStatus(inventory.type)
            let dispositionIntentionStatus = this.getDispositionIntentionStatus(inventory.dispositionIntention)

            let makeModel = {
              makeId: make ? make.id : 0,
              selectedMake: make,
              modelId: model ? model.id : 0,
              selectedModel: model
            }

            let costCompilation = {
              inventory: item.forInventory,
              supplementalCosts: [],
              selectedMakeModel: makeModel,
              selectedTypeStatus: typeStatus,
              selectedDispositionIntentionStatus: dispositionIntentionStatus
            }

            costsCompilation.push(costCompilation)
          }       
        })
      }
      return costsCompilation
    }
  },
  methods: {
    init () {
      this.soldAndTradeItems.forEach(function (item) {
        if (item.forInventory.supplementalCosts.length === 0) {
          this.inventoryMissingCosts = true
          item.inventoryCostsUpdated = true
        }
      }, this)
    },
    saveSupplementalCost: function () {
      this.costsCompilation.forEach(function (x) {
        x.supplementalCosts.forEach(function (cost) {
          var supplementalCost = {
            id: cost.id,
            dealerDefaultCostId: cost.dealerDefaultCostId,
            name: cost.name,
            payeeType: cost.payeeType,
            vendorId: cost.vendorId,
            vendorName: cost.vendorName,
            attachments: cost.attachments,
            processingAction: cost.processingAction,
            description: cost.description,
            cost: cost.cost,
            sellingPrice: cost.sellingPrice,
            isInGlBalance: cost.isInGlBalance,
            appliesToDispositionIntention: cost.appliesToDispositionIntention,
            includeInAgreements: cost.includeInAgreements,
            appliesOnSaleOnly: cost.appliesOnSaleOnly,
            requiresMatchedSaleIntention: cost.requiresMatchedSaleIntention,
            additionalIncome: cost.additionalIncome,
            delete: cost.delete === undefined ? false : cost.delete,
            isAuto: cost.isAuto === undefined || cost.isAuto === null ? false : cost.isAuto
          }
          x.inventory.supplementalCosts.push(supplementalCost)
        }, this)
      }, this)
    },
    getMake: function (vehicleMakeId) {
      let selectedMake = vehicleMakeId > 0 ? this.allVehicleMakes.find((x) => x.id === vehicleMakeId) : null
      return selectedMake
    },
    getModel: function (selectedMake, vehicleMakeVersionId) {
      let selectedModel = selectedMake && selectedMake.versions ? (selectedMake.versions.find((x) => x.id === vehicleMakeVersionId)) : null
      return selectedModel
    },
    getTypeStatus: function (type) {
      let typeStatus = this.definedTypes.inventoryTypes.find((x) => (x.name === type || x.altName === type))
      return typeStatus
    },
    getDispositionIntentionStatus: function (dispositionIntention) {
      let derivedDispostionIntention = dispositionIntention
 
      // If dispositionIntention not set on Inventory, lets determine what it could be by looking at the deal sale type
      if (derivedDispostionIntention === '' && this.value.saleType === 'Retail')
        derivedDispostionIntention = 'Retail'
      else if (derivedDispostionIntention === '') {
        derivedDispostionIntention = 'WholesaleImmediately'
      }

      let dispositionIntentionStatus = this.definedTypes.dispositionIntentionStatuses.find((x) => (x.name === derivedDispostionIntention || x.altName === derivedDispostionIntention))
      return dispositionIntentionStatus
    }
  },
  mounted: function () {
    eventBus.$on('on-add-missing-costs', this.saveSupplementalCost)
    this.init()
  },
  beforeDestroy () {
    eventBus.$off('on-add-missing-costs', this.saveSupplementalCost)
  }
}

</script>

<style scoped>

  .link {
    cursor:pointer

  }

  .active-link {
    color:green
  }

  .modal-card-body {
    width: 640px;
    max-width: 100% !important;
    min-width: 100% !important;
    overflow:auto;
    height: calc(58vh - 10px);
  }

</style>
